export default __webpack_public_path__ + "static/impact-how-image-2fad426f3b63e6b83b8b39c178961736.jpg";